import React from 'react';

type Props = {
    showIf?: boolean;
    label: string | JSX.Element;
    children: React.ReactNode;
};

export const EMPTY_CELL = '\u2014';

export function TableCell({ showIf = true, children }: { showIf?: boolean; children: React.ReactNode }) {
    return <td>{showIf ? children ?? EMPTY_CELL : EMPTY_CELL}</td>;
}

export function TableDetailsBody({ children }: { children: React.ReactNode }) {
    return (
        <div className="table-responsive">
            <table className="table model-details">
                <tbody>{children}</tbody>
            </table>
        </div>
    );
}

export default function TableDetailsRow({ showIf = true, label, children }: Props) {
    return (
        <tr>
            <th>{label}</th>
            <TableCell showIf={showIf}>{children}</TableCell>
        </tr>
    );
}
